import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '../store/index';

import fr from './fr.json';
import de from './de.json';

Vue.use(VueI18n);

export default new VueI18n({
  locale: store.getters['settings/language'],
  fallbackLocale: 'fr',
  silentFallbackWarn: process.env.NODE_ENV === 'production',
  messages: {
    fr,
    de,
  },
});
